/**
 * A non-2xx response from the kontextwerk API.
 *
 * ``detail`` carries the parsed ``detail`` member of the response body when the
 * server sent a structured one. Some server errors are *actionable data*, not
 * just prose — e.g. ``{"code": "terms_not_accepted", "missing_purposes": [...]}``
 * lets a caller route the user to the consent it is missing. Re-parsing the
 * formatted ``message`` to recover that would be guesswork.
 */
export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public detail?: unknown,
  ) {
    super(message);
    this.name = "ApiError";
  }
}
